import { Map } from './map';

export const Training = (props) => {
  return (
    <div id='training'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            <Map
              location={props.data ? props.data.location : 'loading...'}
              zoomLevel={15}
            />
          </div>
          <div className='col-xs-12 col-md-6'>
            <div className='training-text'>
              <h2>Training</h2>
              <p>{props.data ? props.data.paragraph : 'loading...'}</p>
              <p>{props.data ? props.data.paragraph2 : 'loading...'}</p>
              <p>{props.data ? props.data.paragraph3 : 'loading...'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
